import { DcaOrderParams } from './types'

/**
 * Stable identity of a form state. The controller tags its preview with it, so
 * the UI can tell whether the preview on screen belongs to what is typed now.
 * Kept out of dca.ts so the UI can import it without the controller.
 */
export const getDcaParamsKey = (params: DcaOrderParams) =>
  [
    params.owner.toLowerCase(),
    params.tokenIn.toLowerCase(),
    params.tokenOut.toLowerCase(),
    params.totalAmountRaw,
    params.totalExecutions,
    params.interval,
    params.startAt || '',
    // Auto (backend-picked) and an explicit value are different requests.
    params.maxSlippageBps ?? 'auto'
  ].join('|')
